import { UseQueryResult } from '@tanstack/react-query';
import { GatewayError } from '../../clients/gateway-client/gatewayClient';
import { getCompanyThemingSettingsFromAdminSettings } from '../../clients/gateway-client/adminSettingsMappers';
import { useAdminSettingsSelector } from '../../clients/settings-client/adminSettingsQuery';
import { CompanyThemingSettingsData } from '../../clients/gateway-client/types';
import { logError } from '../../utils/logger';
import { useSite } from '../useSite';

const onThemingError = (error: GatewayError): void => {
	logError({ error, impact: 'Error fetching company theming settings' });
};

/**
 * React Query hook for company theming settings, projected from the shared
 * admin-settings query (see `useAdminSettingsSelector`) so mounting this hook
 * adds no extra round trip.
 */
export function useCompanyThemingSettings(): UseQueryResult<
	CompanyThemingSettingsData,
	GatewayError
> {
	const siteContext = useSite({ allowUndefined: true });

	const siteId = siteContext?.site.workspace.cloudId;

	return useAdminSettingsSelector({
		siteId,
		select: getCompanyThemingSettingsFromAdminSettings,
		onError: onThemingError,
	});
}
